import axios from 'App/axios';
import { makeDevicesMsPayload } from 'App/capacitor/device';

export const isTimestampExpired = (
  storedTimestamp: string | undefined,
  expirationTimeMs: number,
): boolean => {
  if (!storedTimestamp) return true;

  const timestamp = new Date(storedTimestamp).getTime();
  if (isNaN(timestamp) || timestamp <= 0) return true;

  return Date.now() - timestamp >= expirationTimeMs;
};

export const validateDevice = async (): Promise<boolean> => {
  try {
    const payload = await makeDevicesMsPayload();
    await axios.put('/v1/devices/validate', payload);

    return true;
  } catch (error) {
    return false;
  }
};
